"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductTreeNodes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const fetch_more_options_utils_1 = require("./fetch-more-options.utils");
const client_constants_1 = require("../../client.constants");
const client_utils_1 = require("../../client.utils");
const hooks_1 = require("../../hooks");
const gql_1 = require("../gql");
const useProductTreeNodes = ({ productTreeId, filter, pageSize = client_constants_1.REQUEST_LIMIT_MEDIUM, options, }) => {
    var _a;
    const { data, previousData, error, fetchMore, refetch, networkStatus, variables, } = (0, react_2.useQuery)(gql_1.GET_ALL_PRODUCT_TREE_NODES, {
        variables: {
            productTreeId,
            filter,
            first: pageSize,
        },
        notifyOnNetworkStatusChange: true,
        skip: (options === null || options === void 0 ? void 0 : options.skip) || !productTreeId,
    });
    const { edges, pageInfo, totalCount = 0 } = (_a = data === null || data === void 0 ? void 0 : data.productTreeNodes) !== null && _a !== void 0 ? _a : {};
    const pagination = (0, hooks_1.usePagination)({
        pageInfo,
        pageSize,
        fetchMore,
        fetchMoreOptions: fetch_more_options_utils_1.fetchMoreOptions,
        networkStatus,
        lastVariables: variables,
    });
    const search = (0, hooks_1.useClientSearch)({ networkStatus, refetch });
    const formattedData = (0, react_1.useMemo)(() => edges === null || edges === void 0 ? void 0 : edges.map((item) => item.node), [edges]);
    const formattedPreviousData = (0, react_1.useMemo)(() => { var _a, _b; return (_b = (_a = previousData === null || previousData === void 0 ? void 0 : previousData.productTreeNodes) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map((item) => item.node); }, [previousData]);
    const isLoading = (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus);
    return {
        data: formattedData || (isLoading ? formattedPreviousData : []) || [],
        isLoading,
        error,
        totalCount,
        pagination,
        search,
    };
};
exports.useProductTreeNodes = useProductTreeNodes;
exports.default = exports.useProductTreeNodes;
